module.exports = __webpack_public_path__ + "images/corners/Circle Slant.77321758010bc7d6d2229147d7639d7d.jpg";